import Button from "@/components/button/Button.tsx";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";
export type FormValuesKey = keyof IntegrationFormData;

const ZAPIER_INIT_URL =
  "https://zapier.com/webintent/create-zap?template=304145&utm_source=partner&utm_medium=embed&u" +
  "tm_campaign=wfe_custom&provider=&entry-point-location=partner_embed&referer=https%3A%2F%2Fuptime.com%2Fintegrations" +
  "%2Fmanage%2F%3Futm_source%3Dpartner%26utm_medium%3Dembed%26utm_campaign%3Dwfe_custom%26referer%3Dhttps%253A%252F%25" +
  "2Fuptime.com%252Fintegrations%252Fmanage%252F&referrer=https%3A%2F%2Fuptime.com%2Fintegrations%2Fmanage%2F%3Futm_so" +
  "urce%3Dpartner%26utm_medium%3Dembed%26utm_campaign%3Dwfe_custom%26referer%3Dhttps%253A%252F%252Fuptime.com%252Finte" +
  "grations%252Fmanage%252F";

export const ZapierForm = () => {
  return (
    <>
      <SetupInfo>
        <div className="p-2">
          Use this integration to send alerts to Zapier so you can connect them with any app in your workflow.
        </div>
        <div className="p-2">
          <strong>IMPORTANT!</strong> This integration can only be created <strong>from Zapier</strong> by going to the{" "}
          <a target="_blank" href="https://zapier.com/apps/uptime/integrations">
            Zapier Dashboard
          </a>{" "}
          and searching for the <strong>Uptime.com</strong> integration.
        </div>
        <div className="p-2">
          <strong>SECURITY NOTE:</strong> For enhanced security, we recommend you create a separate Uptime.com user with{" "}
          <strong>View &amp; Modify</strong> permission for this integration and use that user's the API key in your
          Zapier setup.
        </div>
        <div className="my-2 ps-2">
          <Button as={"a"} target="_blank" href={ZAPIER_INIT_URL}>
            Configure Zapier Workflow
          </Button>
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/360016225099-Configuring-Zapier">
            View {IntegrationModuleInfo[IntegrationModules.ZAPIER].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
